import PropTypes from "prop-types";
import HappinessSurveyGridItem from "./happiness-survey-grid-item";
import { useSelector } from "react-redux";

const propTypes = {
  itemSurveys: PropTypes.array,
  selectedItems: PropTypes.array,
  onClickItem: PropTypes.func,
  isSelectNoneChecked: PropTypes.bool,
};

const HappinessSurveyProductGrid = ({
  itemSurveys,
  selectedItems = [],
  onClickItem = () => {},
  isSelectNoneChecked,
}) => {
  if (!Array.isArray(itemSurveys) || itemSurveys.length === 0) {
    return null;
  }

  const { isMobileViewport: isMobile } = useSelector(state => state.browser ?? {});

  const handleClickItem = bookingId => {
    onClickItem(bookingId);
  };

  return (
    <div
      className={`grid ${isMobile ? "grid-cols-3" : "grid-cols-5"} gap-2`}
      data-test-id="happiness-survey-product-grid">
      {itemSurveys.map(item => {
        const duplicateItems = itemSurveys.filter(i => i.product.id === item.product.id);
        const size = duplicateItems.length > 1 ? item.size : null;

        return (
          <HappinessSurveyGridItem
            productData={item.product}
            bookingId={item.bookingId}
            key={item.bookingId}
            onClick={handleClickItem}
            isSelected={selectedItems.includes(item.bookingId)}
            disabled={isSelectNoneChecked}
            size={size}
          />
        );
      })}
    </div>
  );
};

HappinessSurveyProductGrid.propTypes = propTypes;
export default HappinessSurveyProductGrid;
